import { graphql } from 'GQL/gql';

export const GET_VIEWER_ORGANIZATION = graphql(`
  query GET_VIEWER_ORGANIZATION($organizationId: ID) {
    viewer {
      _id
      organization(organizationId: $organizationId) {
        _id
        userId
        organizationId
        amount
        relCost
        hasPrivilegedAccess
        createdAt
        updatedAt
        roles
        organization {
          _id
          name
          description
          ownerUserId
          avatar
          createdAt
          updatedAt
          domain
          forceDomain
          showMarketOpportunities
          tenant {
            id
            integrationSettings {
              frameworkUrl
              organizationFrameworkId
            }
          }
          settings {
            opportunities {
              market {
                adsOption
                showCompanyIcon
              }
              company {
                tabs {
                  _id
                  show
                  tabLabel
                  tabType
                  rolesLabel
                  description
                  type
                  icon
                  externalLink
                  hasTrends
                }
              }
            }
          }
        }
      }
    }
  }
`);
